import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from '@mui/lab';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import BusinessTaxSubMenu from '@/components/nav/BusinessTaxSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import ExitPopup1120S from '@/components/ui/ExitPopup1120s';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

const Form1120S = () => {
  const [open, setOpen] = useState(false);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Don't miss your payroll tax return deadline.`,
  //   SubHeading:
  //     'E-file Form 940 for easy compliance. File now and save time and stress.',
  //   CtaText: 'E-file Form 940 Now',
  //   CtaSubHeading: `Stay tax compliant with the IRS`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };
  const [closeSticky, setCloseSticky] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [progress, setProgress] = useState(0);
  const handleStickyClose = (): void => {
    setCloseSticky(true);
  };
  const images = [
    <img
      src="/assets/images/1120s-business-details-img.webp"
      key="first"
      alt="Corporation Details"
      id="loading1"
      className="details-images"
    />,
    <img
      src="/assets/images/1120s-income-img.webp"
      key="second"
      alt="Income and Expenses"
      className="details-images"
    />,
    <img
      src="/assets/images/1120s-shareholder-img.webp"
      key="third"
      alt="Shareholder Information"
      className="details-images"
    />,
    <img
      src="/assets/images/1120s-k-1allocation-img.webp"
      key="fourth"
      alt="K-1 Allocations"
      className="details-images"
    />,
    <img
      src="/assets/images/1120s-balance-sheet-img.webp"
      key="fifth"
      alt="Balance Sheet Details"
      className="details-images"
    />,
  ];
  const loader = ['loading1', 'loading2', 'loading3', 'loading4', 'loading5'];
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === images.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (currentIndex === loader.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 10000);

    return () => clearInterval(intervalId);
  }, [currentIndex + 1]);
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 9, 15));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 9, 15)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file IRS Form 1120-S Online for 2025 | TaxZerone"
          description="File IRS Form 1120-S online for your S corporation with TaxZerone. IRS-authorized, accurate K-1 delivery, and industry-best pricing. Start filing now."
          keywords=""
          canonical="business-tax/efile-irs-form-1120-s/"
          jsonLdPricing=""
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="1658"
          ogShareImg=""
        />
      }
    >
      <Hidden smDown>
        {!closeSticky && (
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              width: '100%',
              left: 0,
              right: 0,
              zIndex: 3,
            }}
          >
            <Container
              maxWidth="md"
              sx={{
                backgroundColor: '#fff',
                mx: { xs: 3, lg: 'auto' },
                width: 'auto',
                py: 1.5,
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                boxShadow: '0 0 20px rgba(0,0,0,.5)',
                position: 'relative',
                borderWidth: 2,
                borderColor: '#414042',
                borderStyle: 'solid',
                borderBottom: 'none',
              }}
            >
              <Tooltip title="Close" arrow placement="top">
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={handleStickyClose}
                  sx={{
                    position: 'absolute',
                    right: -12,
                    top: -12,
                    color: '#fff',
                    backgroundColor: '#e11d1d',
                    '&:hover, &:focus': {
                      backgroundColor: '#b01919',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 1, sm: 1, md: 2 }}
                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Box>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{
                      textAlign: { xs: 'center', sm: 'left' },
                      fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                      //  color: '#ccc',
                      lineHeight: 1.3,
                    }}
                  >
                    <strong>Thank you</strong> for trusting{' '}
                    <b style={{ fontWeight: 600, color: '#213e99' }}>
                      TaxZerone
                    </b>{' '}
                    with your Form 1120-S filing.
                  </Typography>
                </Box>
                {/* <Stack direction="row" alignItems="center" spacing={2}>
                  <Countdown date={lastDayTaxSeason} renderer={renderer} />
                  <Hidden mdUp>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        size="medium"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                        sx={{
                          textTransform: 'none',
                          px: 2.5,
                          display: 'inline-block',
                          boxShadow: 'none',
                          borderRadius: 4.2,
                          backgroundColor: '#213e99',
                          whiteSpace: 'nowrap',
                          '&:hover, &:focus': {
                            backgroundColor: '#172b6b',
                          },
                        }}
                      >
                        E-File Now
                      </Button>
                    </Box>
                  </Hidden>
                </Stack>
                <Hidden mdDown>
                  <Box sx={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      size="medium"
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                      sx={{
                        textTransform: 'none',
                        px: 2.5,
                        display: 'inline-block',
                        boxShadow: 'none',
                        borderRadius: 4.2,
                        backgroundColor: '#213e99',
                        whiteSpace: 'nowrap',
                        '&:hover, &:focus': {
                          backgroundColor: '#172b6b',
                        },
                      }}
                    >
                      E-File Now
                    </Button>
                  </Box>
                </Hidden> */}
              </Stack>
            </Container>
          </Box>
        )}
      </Hidden>
      <BusinessTaxSubMenu />
      <ExitPopup1120S />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
        component="section"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #a32cdf, #106ad2)',
            p: 1.5,
            px: 4,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 16, sm: 17, md: 20, lg: '1.24rem' },
                color: '#e0e0e0',
              }}
            >
              <strong>📢 Only 3 Days Left! </strong> E-file Your{' '}
              <span style={{ fontWeight: 600, color: '#eee' }}>
                {' '}
                2025 Extended S Corp (Form 1120-S)
              </span>{' '}
              Filing Today & Distribute Schedule K-1s
            </Typography>
            <Box sx={{}}>
              <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  sept 15, 2026
                </span>
                ):
              </Typography>
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                sx={{
                  backgroundColor: '#ee4266',
                  '&:hover, &:focus': {
                    backgroundColor: '#8338ec',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#fff',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: 18,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-file Now!
              </Button>
              {/* <Typography
                variant="body2"
                sx={{ textAlign: 'center', mt: 1, color: '#fff' }}
              >
                {' '}
                <b style={{ color: '#fff' }}> Save 10%</b> with code{' '}
                <b style={{ color: '#f4d58d' }}> TZOTE10</b>
              </Typography> */}
            </Box>
          </Stack>
        </Box>
      </Container>

      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="header"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File IRS{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 1120-S</span>
                </span>{' '}
                Online for the 2025 Tax Year
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                E-file your S corporation’s income tax return with ease.
                TaxZerone offers a secure, accurate, and IRS-authorized way to
                file Form 1120-S online - whether you&apos;re filing for a
                single S corp or managing multiple entities.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                  >
                    File Form 1120-S
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>

                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: 580,
                  mx: { xs: 'auto', md: 0 },
                  mt: 5,
                }}
              />
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f1120s-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/f1120s-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/f1120s-landing-img.png"
                  alt="File IRS Form 1120-S Online for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f1120s-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/f1120s-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/f1120s-landing-img-sm.png"
                  alt="File IRS Form 1120-S Online for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                File Form 1120-S Online for Just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $179.99{' '}
                </Box>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                One flat fee. No hidden charges. Your complete 1120-S e-filing{' '}
                includes accurate Schedule K1 preparation and generation for all
                shareholders.
              </Typography>
            </Box>
            {/* <Typography variant="body1">Add-on services:</Typography>
              <Box component={'ul'} sx={{ mt: -0.1 }}>
                <li>
                  Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#ffffffff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $1.75
                  </Box>{' '}
                  per recipient
                </li>
                <li>
                  {' '}
                  ZeroneVault Digital Delivery: Postal K-1 Delivery:{' '}
                  <Box
                    component={'strong'}
                    sx={{
                      color: '#fffad1ff',
                      fontSize: { xs: 24, sm: 24 },
                    }}
                  >
                    $0.50
                  </Box>{' '}
                  per recipient{' '}
                </li>
              </Box> */}

            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#businesstax"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  What is IRS Form 1120-S?
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  IRS Form 1120-S is the annual income tax return filed by S
                  corporations. It reports your company’s income, gains, losses,
                  deductions, and credits - and it’s also used to generate
                  Schedule K-1 for shareholders to report on their personal
                  returns.{' '}
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  Form 1120-S is crucial for maintaining S corporation
                  compliance. Late or incorrect filings can result in penalties
                  or loss of irs S corp status.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/form-1120s-img.webp" />
                  <source srcSet="/assets/images/form-1120s-img.png" />
                  <img
                    src="/assets/images/form-1120s-img.png"
                    alt="What is IRS Form 1120-S?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',

          pb: 6,
          pt: 1,
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid size={{ md: 6, xs: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                // sx={{
                //   display: 'flex',
                //   justifyContent: 'center',
                //   alignItems: 'center',
                //   height: '100%',
                //   textAlign: { xs: 'center', md: 'right' },
                //   my: { xs: 3, md: 0 },
                // }}
                className="image-container"
              >
                <Box
                  component={motion.div}
                  key={currentIndex}
                  className="image-fade"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 1.5, ease: 'easeInOut' }}
                  sx={{
                    '& img': { width: '100%', height: { xs: 'auto', md: 500 } },
                  }}
                >
                  {images[currentIndex]}
                </Box>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2,
                  }}
                >
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 0 ? 'loading-effect' : ''}
                    id="loading1"
                  />{' '}
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 1 ? 'loading-effect' : ''}
                    id="loading2"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 2 ? 'loading-effect' : ''}
                    id="loading3"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 3 ? 'loading-effect' : ''}
                    id="loading4"
                  />
                  <Box
                    component="div"
                    sx={{
                      width: 80,
                      backgroundColor: '#e791c66f',
                      height: 10,
                      borderRadius: 3,
                      my: 1,
                    }}
                    className={currentIndex === 4 ? 'loading-effect' : ''}
                    id="loading5"
                  />
                </Stack>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box sx={{ ml: 3 }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 30, md: 26, sm: 24, xs: 22 },
                    fontWeight: 600,
                    mt: 3,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  What You’ll Need to File Form 1120-S
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 5 },
                    mt: { xs: 0, md: 4 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex', mb: 2 },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Corporation Details:
                      </span>{' '}
                      Name, EIN, business address, incorporation date
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Income and Expenses:{' '}
                      </span>{' '}
                      Revenue, cost of goods sold, deductions, and credits
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Shareholder Information:{' '}
                      </span>
                      Name, TIN, percentage ownership, and distributions
                    </Box>
                  </li>
                  <li>
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}> K-1 Allocations:</span>{' '}
                      Profit/loss distributions to each shareholder
                    </Box>
                  </li>
                  <li>
                    {' '}
                    <TaskAltIcon sx={{ mr: 1, mb: -0.6, color: '#1da94a' }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Balance Sheet Details:{' '}
                      </span>
                      Assets, liabilities, and retained earnings
                    </Box>
                  </li>{' '}
                </Box>

                {/* <Typography variant="body1" sx={{ ml: 2, mt: 2 }}>
                  Filing again next year? TaxZerone saves your past filings so
                  you can reuse details and file faster.
                </Typography> */}
                <Box sx={{ ml: 2, mb: 4 }}>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 2,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                  >
                    Start Filing Effortlessly
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 5.5, lg: 5 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Eligibility Checklist: Is Form 1120-S Right for Your Business?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Before you file, make sure your business qualifies:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      {' '}
                      Your business is a{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        domestic corporation or an LLC
                      </span>{' '}
                      that has filed and received IRS approval for <br />
                      <span style={{ fontWeight: 600 }}>
                        Form 2553 (Election by a Small Business Corporation)
                      </span>
                      .
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      You have{' '}
                      <span style={{ fontWeight: 600 }}>
                        income, gains, losses, deductions, or credits
                      </span>{' '}
                      to report from U.S. operations.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Your company has{' '}
                      <span style={{ fontWeight: 600 }}>
                        100 or fewer shareholders.{' '}
                      </span>
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      All shareholders are{' '}
                      <span style={{ fontWeight: 600 }}>U.S. persons</span>{' '}
                      (individuals, estates, certain trusts, or qualifying
                      exempt organizations).{' '}
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      {' '}
                      You issue{' '}
                      <span style={{ fontWeight: 600 }}>
                        only one class of stock
                      </span>
                      .
                    </Box>
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If your business meets these criteria, you are required to
                  file <span style={{ fontWeight: 600 }}>Form 1120-S</span> to
                  report your S Corporation’s income and distribute{' '}
                  <span style={{ fontWeight: 600 }}>Schedule K-1s</span> to
                  shareholders for their individual tax filings.{' '}
                </Typography>
                <Box sx={{ textAlign: { xs: 'center', md: 'left' }, mt: 3 }}>
                  <Typography variant="body1" sx={{ mx: 15, fontWeight: 600 }}>
                    Still Unsure?{' '}
                  </Typography>
                  <Button
                    variant="contained"
                    sx={{
                      mt: 0.5,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                  >
                    Contact Our Support
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6.5, lg: 7 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/1120s-checklist-img.webp" />
                  <source srcSet="/assets/images/1120s-checklist-img.png" />
                  <img
                    src="/assets/images/1120s-checklist-img.png"
                    alt="Eligibility Checklist: Is Form 1120-S Right for Your Business?"
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={550}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      {/* <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
           <Grid
              size={{xs: 12, md: 6}}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Who Must File Form 1120-S?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  You must file Form 1120-S if your business:
                </Typography>
                <Box
                  component={'ul'}
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    Is classified as an S Corporation
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    Has an approved Form 2553 (S Corp Election)
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    Operates as an LLC electing to be taxed as an S Corp / Is an
                    LLC that has filed Form 2553 and is now being taxed as an S
                    Corporation
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    Has income/loss to report from U.S. operations
                  </li>
                </Box>
              </Box>
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
              <Box
                component={'div'}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/who-file-1120s-img.webp" />
                  <source srcSet="/assets/images/who-file-1120s-img.png" />
                  <img
                    src="/assets/images/who-file-1120s-img.png"
                    alt="Who Must File Form 1120-S?"
                    className="img-responsive "
                    loading="lazy"
                    width={500}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid> */}
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to E-file Form 1120-S with TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing your Form 1120-S is quick and easy - just follow these
                steps:
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/1120s-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/1120s-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/1120s-steps-img.png"
                  alt="How to E-file Form 1120-S with TaxZerone"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Company Details"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Company Details
                    </Typography>
                    <Typography variant="body1">
                      Choose Form 1120-S after login and enter corporation and
                      shareholder details via our intuitive interface.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Add Income, Expenses & K-1 Data"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Add Income, Expenses & K-1 Data
                    </Typography>
                    <Typography variant="body1">
                      Input your business income, deductions, and automatically
                      generate K-1s for shareholders.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Validate & E-file "
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Validate & E-file
                    </Typography>
                    <Typography variant="body1">
                      Our built-in validation checks help ensure your return
                      meets IRS standards before submission.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-4-icon.webp" />
                        <source srcSet="/assets/images/step-4-icon.png" />
                        <img
                          src="/assets/images/step-4-icon.png"
                          alt="Distribute K-1s to Shareholders."
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Distribute K-1s to Shareholders.
                    </Typography>
                    <Typography variant="body1">
                      After filing, easily send K-1s digitally via ZeroneVault
                      or by mail.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                >
                  Start Filing 1120-S Now
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for Form 1120-S E-filing?
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            sx={{ justifyContent: 'center', p: 0, listStyleType: 'none' }}
            component="ul"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-Authorized Provider"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS-Authorized Provider
                </Typography>
                <Typography variant="body1">
                  Submit your corporate tax return with full confidence on a
                  trusted, IRS-approved platform.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided Filing
                </Typography>
                <Typography variant="body1">
                  Even if it’s your first time filing irs form 1120 S, our
                  system guides you through every section
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/auto-genert-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/auto-genert-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/auto-genert-icon.png"
                      alt="K-1 Auto-Generation"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  K-1 Auto-Generation
                </Typography>
                <Typography variant="body1">
                  Simplify shareholder reporting with automatic Schedule K-1
                  generation and delivery.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12} component="li">
                &nbsp;
              </Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fast-filing-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fast-filing-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fast-filing-icon.png"
                      alt="Quick Repeat Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Quick Repeat Filing
                </Typography>
                <Typography variant="body1">
                  Returning users can copy prior-year data for faster, easier
                  submissions.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/error-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/error-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/error-icon.png"
                      alt="Advanced Error Checks "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Advanced Error Checks
                </Typography>
                <Typography variant="body1">
                  We scan for missing TINs, calculation errors, and common
                  mistakes-minimizing IRS rejections.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }} component="li">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Transparent Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Transparent Pricing
                </Typography>
                <Typography variant="body1">
                  No hidden charges. Pricing that scales with your needs.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Key Schedules Included with IRS Form 1120-S
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  When filing your S Corporation tax return, several crucial
                  schedules must accompany irs 1120s form to provide a
                  comprehensive financial and tax overview to the IRS:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 3 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Schedule K:</span> This
                      schedule summarizes each shareholder’s share of the
                      corporation’s income, deductions, credits, and other
                      tax-related items for the year.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Schedule K-1:</span>{' '}
                      Provided individually to each shareholder, Schedule K-1
                      details their specific portion of the S Corporation’s
                      income or loss to be reported on their personal tax
                      returns.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Schedule L:</span>{' '}
                      Presents the corporation’s balance sheet, showing assets,
                      liabilities, and equity at the start and end of the tax
                      year.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Schedule M-1:</span>{' '}
                      Reconciles the difference between the corporation’s book
                      income (financial accounting) and taxable income on the
                      return.{' '}
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Schedule M-2:</span>{' '}
                      Tracks changes in the corporation’s retained earnings and
                      accumulated adjustments during the year.
                    </Box>
                  </li>
                </Box>
                <Typography variant="body1">
                  Completing these schedules accurately is essential to comply
                  with IRS regulations and helps prevent errors or delays in
                  processing your tax return.{' '}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    mt: 3,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                >
                  Stay Compliant, File Online
                </Button>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/document-check-img.webp" />
                  <source srcSet="/assets/images/document-check-img.png" />
                  <img
                    src="/assets/images/document-check-img.png"
                    alt="Pre-Filing Document Checklist"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 3 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Filing Form 1120-S IRS Made Simple for Small Corporations
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>{' '}
                  & First-Time Filers
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mb: 0,
                    maxWidth: 900,
                    fontSize: { md: 17, sm: 16, xs: 16 },
                    m: 'auto',
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignContent: 'center',
                  }}
                >
                  Starting an S Corporation comes with big responsibilities-and
                  filing your first{' '}
                  <span style={{ fontWeight: 600 }}> form 1120s irs</span>{' '}
                  doesn’t have to be overwhelming. At{' '}
                  <span style={{ fontWeight: 600 }}>TaxZerone</span>, we
                  simplify the process so you can focus on running your
                  business, not navigating IRS complexities.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 4,
                  minHeight: '100%',
                  backgroundColor: '#e3f2fd',
                  border: 'none',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 24, sm: 20, xs: 18 },
                      mb: 3,
                    }}
                  >
                    Why This Matters for Small Corporations{' '}
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 0 },
                      mt: { xs: 0, md: 4 },
                      mb: { xs: 0, md: 0 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Straightforward Pricing:
                        </span>{' '}
                        A single flat fee with no surprise charges-perfect for
                        businesses managing tight budgets.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Step-by-Step Guidance:{' '}
                        </span>{' '}
                        Our platform is designed for filers with little to no
                        prior experience, breaking down IRS requirements into
                        easy steps.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Automatic K-1 Generation:
                        </span>{' '}
                        Instantly generate and distribute Schedule K-1s for all
                        shareholders without extra work.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Error-Free Filing:
                        </span>{' '}
                        Built-in validation checks catch common mistakes that
                        could delay your return or trigger IRS notices.
                      </Box>
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 4,
                  minHeight: '100%',
                  backgroundColor: '#ccd5ae',
                  border: 'none',
                }}
              >
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 24, sm: 20, xs: 18 },
                      mb: 3,
                    }}
                  >
                    First-Time Filers Get Extra Peace of Mind
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 0 },
                      mt: { xs: 0, md: 4 },
                      mb: { xs: 0, md: 0 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Clear Explanations at Every Step:
                        </span>{' '}
                        We keep things easy to understand by avoiding complex
                        tax terminology.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Free Resources & FAQs:
                        </span>{' '}
                        Access practical guides tailored for new S Corporation
                        owners.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        <span style={{ fontWeight: 600 }}>
                          Dedicated Support Team:
                        </span>{' '}
                        Whether it’s your first filing or you just need
                        reassurance, our experts are ready to help.
                      </Box>
                    </li>
                  </Box>
                  <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
                    <Button
                      variant="contained"
                      sx={{
                        mt: 4,
                        backgroundColor: '#fff !important',
                        color: '#333 !important',
                        transition: 'all 0.3s ease 0s',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.1)',
                        },
                      }}
                      className="btn-primary"
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                    >
                      Start Filing Now
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ md: 6, xs: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/1120s-tax-professional-img.webp" />
                  <source srcSet="/assets/images/1120s-tax-professional-img.png" />
                  <img
                    src="/assets/images/1120s-tax-professional-img.png"
                    alt="Special Pricing for CPAs & Tax Professionals"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  Special Pricing for CPAs & Tax Professionals
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  Got more than one 1120-S to file? Let’s talk savings. We offer
                  exclusive bulk discounts, flexible pricing, and white-glove
                  support for tax professionals and CPAs handling multiple
                  businesses.
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li> Bigger filings = Bigger discounts</li>
                  <li>Save time with reusable business profiles</li>
                </Box>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  📞{' '}
                  <Link href="/contact-us/" sx={{ color: '#0202ff' }}>
                    Contact Us Now
                  </Link>{' '}
                  to unlock your custom CPA pricing and make this tax season
                  your easiest yet.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'left',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  For Fiscal-Year S Corporations
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If your S corp uses a{' '}
                  <span style={{ fontWeight: 600 }}> fiscal year</span> (any
                  year ending on a month other than December), the due date is:
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, fontWeight: 600 }}>
                  The 15th day of the 3rd month after your fiscal year
                  ends.{' '}
                </Typography>

                <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                  Example:
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 1 },
                    mb: { xs: 0, md: 2 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon
                      sx={{ color: '#1da94a', mr: 1, mb: -0.8 }}
                    />{' '}
                    <Box>
                      If your fiscal year ends{' '}
                      <span style={{ fontWeight: 600 }}>June 30, 2026</span>,
                      your 1120-S is due{' '}
                      <span style={{ fontWeight: 600 }}>
                        September 15, 2026
                      </span>
                      .
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon
                      sx={{ color: '#1da94a', mr: 1, mb: -0.8 }}
                    />{' '}
                    <Box>
                      If your fiscal year ends{' '}
                      <span style={{ fontWeight: 600 }}>
                        September 30, 2026
                      </span>
                      , your 1120-S is due{' '}
                      <span style={{ fontWeight: 600 }}>December 15, 2026</span>
                      .
                    </Box>
                  </li>
                </Box>

                <Box sx={{ p: 2, backgroundColor: '#caf0f8', borderRadius: 3 }}>
                  <Typography variant="body1" sx={{ mb: 1, fontWeight: 600 }}>
                    Need more time to file Form 1120-S?
                  </Typography>
                  <Typography variant="body1">
                    {' '}
                    You can request an extension by filing{' '}
                    <Link
                      href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      IRS Form 7004
                    </Link>{' '}
                    before the due date.
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/1120s-fiscal-img.webp" />
                  <source srcSet="/assets/images/1120s-fiscal-img.png" />
                  <img
                    src="/assets/images/1120s-fiscal-img.png"
                    alt="For Fiscal-Year S Corporations:"
                    className="img-responsive"
                    loading="lazy"
                    width={500}
                    height={500}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Form 1120-S Filing Deadlines – 2025 Tax Year
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  These deadlines apply if your S corporation uses a{' '}
                  <span style={{ fontWeight: 600 }}> calendar year</span> (Jan 1
                  – Dec 31).
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Deadline
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{ backgroundColor: '#fff' }}>
                          <TableCell>File with IRS (E-file) </TableCell>
                          <TableCell>March 16, 2026</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Shareholder K-1 distribution </TableCell>
                          <TableCell>March 16, 2026 </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#fff' }}>
                          <TableCell>
                            With Extension (
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 7004
                            </Link>
                            ){' '}
                          </TableCell>
                          <TableCell>September 15, 2026</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Alert severity="warning" icon={false} sx={{ mb: 0 }}>
                  <b>Note:</b> Deadlines shift to the next business day if they
                  fall on a weekend/holiday.
                </Alert>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ md: 6, xs: 12 }} sx={{ mt: 4 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
                className="image-container"
              >
                <picture>
                  <source srcSet="/assets/images/1120s-penalties-late-img.webp" />
                  <source srcSet="/assets/images/1120s-penalties-late-img.png" />
                  <img
                    src="/assets/images/1120s-penalties-late-img.png"
                    alt="Penalties for Late or Inaccurate Filing"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                textAlign: { md: 'left', sm: 'left' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                m: 0,
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mt: 3,

                    textAlign: 'left',
                  }}
                >
                  Penalties for Late or Inaccurate Filing
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  Avoid costly penalties by filing on time:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}> Late filing:</span> $255
                    per shareholder for each month late (max 12 months). If you
                    owe tax, add 5% of the unpaid amount each month (max 25%).
                    If your 2025 return is over 60 days late, you’ll pay at
                    least the smaller of your tax due or $525.{' '}
                    <Link
                      href="https://www.irs.gov/pub/irs-pdf/i1120s.pdf"
                      target="_blank"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      IRS 1120-S/PDF
                    </Link>{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Missing/incorrect K-1s:
                    </span>{' '}
                    $330 per K-1 (rises for intentional disregard).{' '}
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mt: 2 }}>
                  If you’re unsure, contact a CPA or{' '}
                  <Link href="/contact-us/" sx={{ color: '#0202ff' }}>
                    {' '}
                    our support
                  </Link>{' '}
                  - we’ll help you avoid errors and penalties.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Stack
                spacing={2}
                direction={{ xs: 'column-reverse', md: 'row' }}
                sx={{
                  p: 3,
                  borderRadius: 4,
                  border: 'none',
                  backgroundColor: '#fff',
                  minHeight: '100%',
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'left',
                    }}
                  >
                    Common Use Cases
                  </Typography>
                  <Box component="ul" sx={{ mb: 1, '& li': { mb: 1.2 } }}>
                    <li>Annual return for single-member S Corp </li>
                    <li>K-1 generation for multiple shareholders </li>
                    <li>Filing with state-level add-ons</li>
                    <li>
                      Converting from LLC to S Corp and filing for the first
                      time{' '}
                    </li>
                    <li>
                      Preparing accurate irs 1120s filings for clients with
                      multiple S corporations{' '}
                    </li>
                  </Box>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Not sure if you need to file irs form 1120s?
                    </span>{' '}
                    Our support team can help you determine your requirements.
                  </Typography>
                </Box>
                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    textAlign: { xs: 'center', md: 'right' },
                    my: { xs: 3, md: 0 },
                  }}
                  className="image-container"
                >
                  <picture>
                    <source srcSet="/assets/images/1120s-common-image.webp" />
                    <source srcSet="/assets/images/1120s-common-image.png" />
                    <img
                      src="/assets/images/1120s-common-image.png"
                      alt=" Common Use Cases"
                      className="img-responsive"
                      loading="lazy"
                      width={470}
                      height={318}
                    />
                  </picture>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  borderRadius: 3,
                  border: 'none',
                  maxWidth: 950,
                  m: 'auto',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 2,
                    textAlign: 'center',
                  }}
                >
                  Common Mistakes to Avoid
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    textAlign: 'center',
                    fontSize: 18,
                    fontStyle: 'italic',
                    fontWeight: 500,
                  }}
                >
                  (Pro Tips from a Tax Expert)
                </Typography>

                <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                  {' '}
                  <li>
                    Make sure your shareholder compensation is “reasonable.” The
                    IRS often audits S Corps that report high distributions but
                    low salaries.
                  </li>
                  <li>
                    If your S Corp had no activity this year, you still must
                    file 1120-S (just mark it as a final or zero-activity
                    return).
                  </li>
                  <li>Double-check TINs to avoid rejection </li>
                  <li>Don’t miss the irs form 1120-S K-1 delivery deadline </li>
                  <li>Match total distributions with retained earnings </li>
                  <li>Use correct codes on Schedule K </li>
                </Box>

                <Alert severity="info" id="whatare" icon={false} sx={{ mb: 1 }}>
                  <b>Tips:</b> TaxZerone flags common errors before you submit!
                </Alert>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={12}
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                {/* Competitor Comparison: Why TaxZerone Wins */}
                TaxZerone vs. Other Form 1120-S E-Filing Platforms
              </Typography>

              <TableContainer
                sx={{
                  border: '1px solid #828282',
                  mb: 4,
                  maxWidth: 800,
                  m: 'auto',
                }}
              >
                <Table sx={{}} aria-label="Due Date Chart">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#ccc', fontWeight: 600 }}>
                      <TableCell
                        sx={{
                          color: '#444',
                          width: 300,
                          fontWeight: 600,
                          fontSize: { md: 18, sm: 16, xs: 16 },
                        }}
                      >
                        Feature
                      </TableCell>
                      <TableCell
                        sx={{
                          color: '#444',
                          width: 300,
                          fontWeight: 600,
                          fontSize: { md: 18, sm: 16, xs: 16 },
                        }}
                      >
                        TaxZerone
                      </TableCell>

                      <TableCell
                        sx={{
                          color: '#444',
                          width: 300,
                          fontWeight: 600,
                          fontSize: { md: 18, sm: 16, xs: 16 },
                        }}
                      >
                        Other E-file Platforms
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell
                        sx={{
                          fontSize: { md: 16, sm: 16, xs: 16 },
                          fontWeight: 600,
                        }}
                      >
                        IRS-Authorized{' '}
                      </TableCell>
                      <TableCell>✅ 100% trusted by the IRS</TableCell>
                      <TableCell>✅ Available</TableCell>
                    </TableRow>
                    <TableRow sx={{}}>
                      <TableCell
                        sx={{
                          fontSize: { md: 16, sm: 16, xs: 16 },
                          fontWeight: 600,
                        }}
                      >
                        Built-in Error Validation{' '}
                      </TableCell>
                      <TableCell
                        sx={{
                          display: 'flex',
                          textAlign: 'left',
                          justifyContent: 'center',
                        }}
                      >
                        ✅{' '}
                        <Box sx={{ ml: 0.5 }}>
                          {' '}
                          Automatic error check before submission
                        </Box>
                      </TableCell>
                      <TableCell>⚠️Limited or manual checks</TableCell>
                    </TableRow>
                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell
                        sx={{
                          fontSize: { md: 16, sm: 16, xs: 16 },
                          fontWeight: 600,
                        }}
                      >
                        K-1 Generation & Delivery
                      </TableCell>
                      <TableCell
                        sx={{
                          display: 'flex',
                          textAlign: 'left',
                          justifyContent: 'center',
                        }}
                      >
                        ✅{' '}
                        <Box sx={{ ml: 0.5 }}>
                          Instant K-1 creation + postal & digital delivery
                          options
                        </Box>
                      </TableCell>
                      <TableCell>✅ Basic K-1 generation only</TableCell>
                    </TableRow>
                    <TableRow sx={{}}>
                      <TableCell
                        sx={{
                          fontSize: { md: 16, sm: 16, xs: 16 },
                          fontWeight: 600,
                        }}
                      >
                        Transparent Pricing{' '}
                      </TableCell>
                      <TableCell
                        sx={{
                          display: 'flex',
                          textAlign: 'left',
                          justifyContent: 'center',
                        }}
                      >
                        ✅{' '}
                        <Box sx={{ ml: 0.5 }}>
                          Flat fee + clear add-ons (no surprises)
                        </Box>{' '}
                      </TableCell>
                      <TableCell>❌ Hidden charges & upsells</TableCell>
                    </TableRow>
                    <TableRow sx={{ backgroundColor: '#fff' }}>
                      <TableCell
                        sx={{
                          fontSize: { md: 16, sm: 16, xs: 16 },
                          fontWeight: 600,
                        }}
                      >
                        Support Team Access
                      </TableCell>
                      <TableCell
                        sx={{
                          display: 'flex',
                          textAlign: 'left',
                          justifyContent: 'center',
                        }}
                      >
                        ✅{' '}
                        <Box sx={{ ml: 0.5 }}>
                          Expert help via chat, email, & phone
                        </Box>
                      </TableCell>
                      <TableCell>Limited or delayed support </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
                >
                  File Form 1120-S Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
        component="section"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to E-file IRS Form 1120-S?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Avoid penalties, save time, and stay compliant - file securely with
          TaxZerone in minutes.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1120s`}
          >
            Start Filing Form 1120-S Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg" component="section" aria-labelledby="1120s-faqs">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              id="1120s-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is the difference between IRS Form 1120 and 1120-S?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      IRS 1120 Form is for{' '}
                      <span style={{ fontWeight: 600 }}> C corporations</span>,
                      which are taxed at the corporate level. Form 1120‑S is for{' '}
                      <span style={{ fontWeight: 600 }}>S corporations</span>,
                      where profits and losses pass through to shareholders to
                      avoid double taxation. Foreign or domestic corporations
                      with more than 100, or non-U.S., shareholders generally
                      use 1120.
                    </Typography>
                    <Alert
                      icon={false}
                      severity="warning"

                      sx={{
                        mt: 2,
                        mb: 0,
                        borderLeft: '3px solid rgb(102, 60, 0)',
                      }}
                    >
                      <b>Note :</b> To learn more in detail, check out our Page
                      on the{' '}
                      <Link
                        href="/resources/business-tax/form-1120s-vs-form-1120-comparison/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        differences between Form 1120 IRS and Form 1120-S
                      </Link>
                      .
                    </Alert>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What tax forms do I file as an S Corp?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      As an S corporation, you must file Form 1120‑S. You also
                      issue{' '}
                      <span style={{ fontWeight: 600 }}>Schedule K‑1</span> to
                      each shareholder to report their share of income,
                      deductions, or credits.
                    </Typography>
                    <Alert
                      icon={false}
                      severity="warning"
                      sx={{
                        mt: 2,
                        mb: 0,
                        borderLeft: '3px solid rgb(102, 60, 0)',
                      }}
                    >
                      <b>Note :</b> If you&apos;re filing an S Corporation
                      return, check out our line-by-line{' '}
                      <Link
                        href="/resources/business-tax/form-1120-s-instructions/"
                        sx={{ color: '#0202ff' }}
                      >
                        IRS 1120s Instructions
                      </Link>
                    </Alert>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Is my LLC automatically a 1120 or 1120-S?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                    No. By default, an LLC is taxed as a sole proprietorship
                    (single member) or partnership (multi-member). To be taxed
                    as an S Corp, you must file{' '}
                    <span style={{ fontWeight: 600 }}> Form 2553</span>. Only
                    then do you file{' '}
                    <span style={{ fontWeight: 600 }}>Form 1120‑S</span>, not
                    irs tax form 1120.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  How do I tell if a company is an S-Corp or C Corp?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="p" sx={{ mt: 1 }}>
                      Check if the IRS has accepted{' '}
                      <span style={{ fontWeight: 600 }}>Form 2553</span> for the
                      entity. If yes, it’s an{' '}
                      <span style={{ fontWeight: 600 }}>S corporation</span> and
                      files Form 1120‑S. Otherwise, it’s treated as a{' '}
                      <span style={{ fontWeight: 600 }}>C corporation</span> and
                      files 1120 irs form.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  Can I tell if I am an S Corp or C Corp?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="p" itemProp="text" sx={{ mt: 1 }}>
                    Yes. Review your IRS filings: if you filed and were approved
                    using <span style={{ fontWeight: 600 }}> Form 2553</span>,
                    your business is an{' '}
                    <span style={{ fontWeight: 600 }}>S corp</span>. If not, or
                    if you receive a regular corporate tax return notice, you
                    are a C corp.
                  </Typography>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  // defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Free Resources Section
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                      <span style={{ fontWeight: 600 }}> Add-ons:</span> <br />
                      <ul>
                        <li style={{ marginBottom: 8 }}>
                          IRS Form 1120-S Instructions (
                          <Link
                            href="https://www.irs.gov/pub/irs-pdf/f1120s.pdf"
                            target="_blank"
                            sx={{ color: '#0202ff' }}
                          >
                            Download
                          </Link>
                          ){' '}
                        </li>
                        <li style={{ marginBottom: 0 }}>
                          IRS Form 2553{' '}
                          <Link
                            href="https://www.irs.gov/pub/irs-pdf/f2553.pdf"
                            target="_blank"
                            sx={{ color: '#0202ff' }}
                          >
                            Download
                          </Link>{' '}
                        </li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1120S;
